// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1W9E1","dark":"Logo_dark__3YOAR","light":"Logo_light__1Guiw"};